import Vue from 'vue';
import { openLoading, closeLoading } from './saas-loading-utils.js'
const resolveConfig = (el, binding) => {
    return {
        'loading-text': el.getAttribute('loading-text') || undefined,
        'loading-text-color': el.getAttribute('loading-text-color') || undefined,
        simple: binding.modifiers.simple,
        textless: binding.modifiers.textless,
        'loading-custom-image': el.getAttribute('loading-custom-image') || undefined,
        'loading-background': el.getAttribute('loading-background') || undefined,
        'loading-spinner': el.getAttribute('loading-spinner') || undefined,
    }
}
export default () => {
    Vue.directive('loading', {
        inserted: function (el, binding) {
            let ele = binding.modifiers.fullscreen ? document.body : el
            if (binding.value) {
                openLoading(ele, resolveConfig(el, binding))
            } else {
                closeLoading(ele)
            }
        },
        update: function (el, binding) {
            if (binding.oldValue !== binding.value) {
                let ele = binding.modifiers.fullscreen ? document.body : el
                if (binding.value) {
                    openLoading(ele, resolveConfig(el, binding))
                } else {
                    closeLoading(ele)
                }
            }
        },
        unbind: function (el, binding) {
            let ele = binding.modifiers.fullscreen ? document.body : el
            closeLoading(ele)
        }
    });
};
